module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/uk-card-drag.51d262bb1899d29e25c2.gif";